<template>
  <div class="page-header-box">
    <span class="title-text">{{title}}</span>
    <div class="header-extra">
      <slot name="extra" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-header-box {
    height: 72px;
    margin: 0 32px;
    background: rgba(255, 255, 255, 0);
    box-shadow: inset 0px -1px 0px 0px #CACED4;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

</style>
